import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, string>({
        query: (id) => ({
            url: `${APP_ENDPOINTS.ACCOUNTS}/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: [
            { type: 'company-owners', id: 'GET' },
            { type: 'company-owners-with-join', id: 'GET-JOIN' },
        ],
    });
